import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class CompanyHolidayService extends BaseService {
  constructor(protected override http: HttpClient) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/holidays`);
  }

  getDates(companyId: string): Observable<string[]> {
    return this.http.get<any>(`${environment.apiBaseUrl}/companies/${companyId}/holidays`)
      .pipe(map(res => res || []));
  }

  saveDates(companyId: string, dates: string[]): Observable<any> {
    return this.http.post<any>(`${environment.apiBaseUrl}/companies/${companyId}/holidays`, { dates });
  }
}
